module.exports = __webpack_public_path__ + "static/media/SVID_S_6.6bdb378e.png";